
// Each Trustpilot widget style is just a different template-id plus its own
// dimensions and token. VARIANTS maps a friendly name to that config so
// callers can switch style with a single prop:
// <UITrustpilotWidget variant="micro-combo" />
const VARIANTS = {
  'micro-star': {
    templateId: '5419b732fbfb950b10de65e5',
    height: '24px',
    width: '100%',
    token: 'b9560582-9aba-4d33-86a4-dc5ef541eb13'
  },
  'micro-button': {
    templateId: '5419b757fa0340045cd0c938',
    height: '25px',
    width: '100%',
    token: 'a100a20f-6ff7-4cd2-bd79-1f9dc821613c'
  },
  'micro-combo': {
    templateId: '5419b6ffb0d04a076446a9af',
    height: '20px',
    width: '100%',
    token: 'f810a7f9-2a6c-4c9d-b2b6-9bcd40492330'
  },
  'micro-review-count': {
    templateId: '5419b6a8b0d04a076446a9ad',
    height: '24px',
    width: '100%',
    token: 'a764334a-ceac-4738-98fa-c5e31c5bf066',
    // This widget takes two extra attributes the others don't
    extra: {
      'data-min-review-count': '0',
      'data-style-alignment': 'center'
    }
  },
  'micro-trustscore': {
    templateId: '5419b637fa0340045cd0c936',
    height: '20px',
    width: '100%',
    token: 'b07e0fcb-5c6c-4044-b5de-20adf1eb1bfa'
  },
  'mini': {
    templateId: '53aa8807dec7e10d38f59f32',
    height: '150px',
    width: '100%',
    token: 'd5f29f42-acc8-486a-83fc-86e9385b5bee'
  },
  'starter': {
    templateId: '5613c9cde69ddc09340c6beb',
    // Height is 100% - needs a parent with a defined height (see note)
    height: '100%',
    width: '100%',
    token: '47b72201-841e-486d-8359-4f3c96e16e71'
  }
}

export default {
  name: 'TrustpilotWidget',

  props: {
    // Which widget style to render - must be a key in VARIANTS
    variant: {
      type: String,
      default: 'micro-star',
      validator (value) {
        return Object.prototype.hasOwnProperty.call(VARIANTS, value)
      }
    },
    // 'light' (default dark text) or 'dark' (white text, for dark backgrounds)
    theme: {
      type: String,
      default: 'light',
      validator (value) {
        return value === 'light' || value === 'dark'
      }
    },
    // Shared across all widgets - sensible defaults, override if needed
    locale: {
      type: String,
      default: 'en-GB'
    },
    businessUnitId: {
      type: String,
      default: '5202059000006400057558c1'
    },
    // Fallback token if a variant somehow lacks one - variants set their own
    token: {
      type: String,
      default: 'b9560582-9aba-4d33-86a4-dc5ef541eb13'
    },
    reviewUrl: {
      type: String,
      default: 'https://www.trustpilot.com/review/www.tefl.org'
    }
  },

  computed: {
    // Resolve the active variant's config, falling back to micro-star
    config () {
      return VARIANTS[this.variant] || VARIANTS['micro-star']
    }
  },

  // Re-render if the variant or theme is switched at runtime
  watch: {
    variant () {
      this.initWidget()
    },
    theme () {
      this.initWidget()
    }
  },

  mounted () {
    this.loadScript().then(this.initWidget)
  },

  methods: {
    // Injects the TrustBox script once, resolves when it's ready
    loadScript () {
      if (window.Trustpilot) {
        return Promise.resolve()
      }

      const existing = document.getElementById('trustpilot-widget-script')

      if (existing) {
        return new Promise(function (resolve) {
          existing.addEventListener('load', resolve)
        })
      }

      return new Promise(function (resolve) {
        const script = document.createElement('script')
        script.id = 'trustpilot-widget-script'
        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        script.async = true
        script.addEventListener('load', resolve)
        document.head.appendChild(script)
      })
    },

    // Tells Trustpilot to render this specific widget element
    initWidget () {
      if (window.Trustpilot && this.$refs.trustbox) {
        window.Trustpilot.loadFromElement(this.$refs.trustbox, true)
      }
    }
  }
}
